import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions d'utilisation</h1>
        <div className="prose prose-blue max-w-none">
          <p>Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <h2>1. Acceptation des conditions</h2>
          <p>
            En utilisant Sibystock, vous acceptez ces conditions d'utilisation.
          </p>

          <h2>2. Description du service</h2>
          <p>
            Sibystock est une plateforme de gestion d'entreprise à distance.
          </p>

          <h2>3. Obligations de l'utilisateur</h2>
          <p>
            En tant qu'utilisateur, vous vous engagez à :
          </p>
          <ul>
            <li>Fournir des informations exactes</li>
            <li>Maintenir la confidentialité de votre compte</li>
            <li>Utiliser le service de manière légale</li>
          </ul>

          <h2>4. Propriété intellectuelle</h2>
          <p>
            Tous les droits de propriété intellectuelle sont réservés.
          </p>

          <h2>5. Limitation de responsabilité</h2>
          <p>
            Sibystock ne peut être tenu responsable des dommages indirects.
          </p>

          <h2>6. Modifications</h2>
          <p>
            Nous nous réservons le droit de modifier ces conditions à tout moment.
          </p>
        </div>
      </main>
    </div>
  );
}